/**
 * Main page implementation.
 */

'use strict';

var Page          = require('stb-component-page'),
    page          = new Page({$node: window.pageMain}),
    LayoutList    = require('mag-component-layout-list'),
    ScrollBar     = require('stb-component-scrollbar'),
    Footer        = require('mag-component-footer'),
    app           = require('mag-app'),
    api           = require('../modules/api'),
    contentRender = require('../modules/content.render'),
    keys          = require('stb-keys'),
    ui            = require('../modules/ui'),
    modal         = require('../modules/modal'),
    handlers      = require('../modules/handlers'),
    contentScroll = new ScrollBar(),
    contentList;

/* global STANDALONE */

page.add(
    app.list = contentList = new LayoutList({
        $node: document.getElementById('contentList'),
        data: [],
        propagate: false,
        cycle: true,
        scroll: contentScroll,
        size: 9
    })
);

document.getElementById('content').appendChild(contentScroll.$node);

page.on('show', function () {
    if ( contentList.data.length ) {
        ui.showContent();
        contentList.focus();
    } else {
        ui.showHelp();
    }
});

api.on('share', function ( content ) {
    var result = [],
        index;

    for ( index = 0; index < content.length; index++ ) {
        result.push(contentRender(content[index]));
    }

    if ( result.length && !contentList.visible ) {
        ui.showContent();
        contentList.focus();
    }

    result = result.concat(contentList.data);

    contentList.setData({
        data: result,
        focusIndex: 0
    });
});


app.footer = new Footer({
    parent: page,
    data: {
        left:  {
            code: keys.menu,
            action: function () {
                console.log('menu');
                modal.show();
            }
        },
        middle: [
            {
                code: keys.f1,
                action: handlers.deleteContent,
                title: gettext('Delete')
            }
        ]
    }
});

page.add(modal);

page.on('keydown', function ( event ) {
    var exitCode = STANDALONE ? keys.exit : keys.back;

    if ( event.code === exitCode ) {
        // just fix some core bug :)
        setTimeout(function () {
            if ( STANDALONE ) {
                core.notify({
                    title: gettext('Exit app ?'),
                    icon: 'alert',
                    timeout: 5000,
                    buttons: [
                        {
                            value: gettext('Ok'),
                            click: function () {
                                api.saveState();
                                app.exit();
                            }
                        },
                        {
                            value: gettext('Cancel'),
                            click: function () { /**/ }
                        }
                    ]
                });
            } else {
                api.saveState();
                app.exit();
            }

        }, 0);
    }
});

// public
module.exports = page;
